/**
 * Creates new reference-container-objects, to be used as value for e.g.
 * the `ItemContainerRef` or `TwoWayBindableRef` injection tokens.
 *
 * ---
 * For more details how to use, see e.g. `ComboboxComponent`'s providers section.
 */
export const RefTokenFactory = () => ({});
